module.exports = __webpack_public_path__ + "static/media/aboutus-transpareny-1.6f26e649.jpg";